import React from 'react';
import * as _ from 'lodash';
import MerchantDetailsComponentProps from '../merchantDetailsComponentProps';
import CommodityLimitSettings from './CommodityLimitSettings';
import CommodityLimitSchedule from './CommodityLimitSchedule';

import './RiskSettings.scss'
import { Form } from 'react-bootstrap';
import Merchant from 'domain/merchant';
import merchantService, { UpdateMerchantRequest } from '../merchantService';
import notificationService from 'common/notificationService';
import loggingService from 'common/logging/loggingService';

const RiskSettings: React.FC<MerchantDetailsComponentProps> = props => {

    async function handleUpdateMerchant(updatedMerchant: Merchant, request: UpdateMerchantRequest) {
        const existingMerchant = props.merchant;

        props.setMerchant(updatedMerchant);
        try {
            await merchantService.updateMerchant(props.merchant.id, request);
        }
        catch (err) {
            notificationService.error("Unable to update merchant");
            loggingService.error("Unable to update merchant", err as Error);
            props.setMerchant(existingMerchant);
        }
    }
    
    return <div className="risk-settings-page">
        <div className="row">
            <div className="col-md-2">
                <label className="pr-1" htmlFor="bypass-risk-service-switch">Bypass Risk Service</label>
            </div>
            <div className="col-md-2">
                <Form.Check
                    type="switch"
                    id="bypass-risk-service-switch"
                    label=""
                    checked={props.merchant.enableRiskServiceBypass}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        const isChecked = event.target.checked;
                        handleUpdateMerchant({ ...props.merchant, enableRiskServiceBypass: isChecked }, { enableRiskServiceBypass: isChecked })
                    }}
                />
            </div>
        </div>
        <div className="row">
            <div className="col-8">
                <CommodityLimitSettings merchantId={props.merchant.id} disabled={props.merchant.enableRiskServiceBypass} />
            </div>
            <div className="col-4">
                <CommodityLimitSchedule />
            </div>
        </div>
    </div>;
}

export default RiskSettings;